export const REPORT_PROGRESS_HEADER = 'report-progress-id';
export const REPORT_PATH = '/report';
export const DAY_OFF_PATH = '/dayoff?';
export const QUERY_SEPARATOR = '?';
export const REPORT_DATE_QUERY_KEY = 'data';
export const HTTP_RESPONSE_OBSERVE: 'response' = 'response';
export const USER_REPORT_SERVICE_REQUIRED =
  'UserReportService is required for report requests';



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/user-report.constants.ts